import React from 'react'
import { Formik, Form } from 'formik'
import Input from '../FormComponents/Input'
import { PotentialInfluencerSignupDeSchema } from '../../schemas/PotentialInfluencerSignupDeSchema';
import axiosService from '../../utils/AxiosService';
import { useNavigate } from 'react-router-dom';
import { toastError } from '../FormComponents/Toasts';

export default function InfluencerSignup() {
  const navigate = useNavigate()

  const handleSignup = (potentialInfluencer) => {
    axiosService.post('/api/influencer/signup/potential_influencers', { potential_influencer: potentialInfluencer })
    .then(response => {
      navigate('/de/influencer/signup/success')
    })
    .catch(error => {
      console.log(error)
      toastError(error.data.error_message)
    })
  }

  return (
    <div className="relative isolate flex min-h-screen w-full items-center justify-center overflow-x-hidden overflow-y-auto bg-rb-grey px-4 py-6 text-rb-black [color-scheme:light] sm:px-6" style={{ minHeight: '100dvh' }}>
      <img src="/static/background_images/login-shape-left.png" alt="bottom corner lines" className="pointer-events-none absolute -bottom-24 -left-28 z-0 w-72 max-w-none opacity-70 sm:-bottom-28 sm:-left-24 sm:w-96 lg:w-[32rem]" />
      <img src="/static/background_images/login-shape-right.png" alt="top corner lines" className="pointer-events-none absolute -right-32 -top-24 z-0 w-72 max-w-none opacity-70 sm:-right-24 sm:-top-28 sm:w-96 lg:w-[32rem]" />
      <div className="relative z-10 my-4 w-full max-w-md rounded-2xl bg-white p-5 text-rb-black shadow-sm sm:p-7">
        <div className="mb-6 text-center">
          <h2 className="text-2xl font-bold leading-tight text-rb-black">Lasse dich als Influencer listen</h2>
          <p className="mt-2 text-sm text-rb-lighter-grey">Werde Teil unseres Netzwerks</p>
        </div>
        <Formik
          initialValues={{
            name: '',
            email: '',
            instagram_username: '',
            tiktok_username: '',
            youtube_username: '',
            linkedin_username: '',
            tc_accepted: false,
            legal_age_accepted: false,
            privacy_policy_accepted: false,
            newsletter_opt_in: false,
          }}
          validationSchema={PotentialInfluencerSignupDeSchema}
          onSubmit={handleSignup}
        >
          {({ errors, touched, handleBlur, handleChange, values }) => (
            <Form className="flex w-full flex-col">
              <div>
                <Input
                  autoComplete="name"
                  error={touched.name && errors.name}
                  forceLight
                  inputPaddingClass="px-3"
                  label="Name"
                  name="name"
                  noLabelPadding
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Dein vollständiger Name"
                  topMargin="mt-0"
                  value={values.name}
                />
              </div>
              <div>
                <Input
                  autoComplete="email"
                  error={touched.email && errors.email}
                  forceLight
                  inputPaddingClass="px-3"
                  label="Email"
                  name="email"
                  noLabelPadding
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="du@example.com"
                  topMargin="mt-4"
                  type="email"
                  value={values.email}
                />
              </div>
              <div className="mb-1 mt-6 rounded-xl bg-rb-grey px-4 py-3 text-center text-sm text-rb-mat-grey">
                Füge so viele <span className="font-semibold text-rb-green">Kanäle</span> hinzu, wie du möchtest.
              </div>
              <div>
                <Input
                  error={touched.instagram_username && errors.instagram_username}
                  forceLight
                  inputPaddingClass="px-3"
                  label="Instagram"
                  name="instagram_username"
                  noLabelPadding
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="@username"
                  topMargin="mt-4"
                  value={values.instagram_username}
                />
              </div>
              <div>
                <Input
                  error={touched.tiktok_username && errors.tiktok_username}
                  forceLight
                  inputPaddingClass="px-3"
                  label="TikTok"
                  name="tiktok_username"
                  noLabelPadding
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="@username"
                  topMargin="mt-4"
                  value={values.tiktok_username}
                />
              </div>
              <div>
                <Input
                  error={touched.youtube_username && errors.youtube_username}
                  forceLight
                  inputPaddingClass="px-3"
                  label="Youtube"
                  name="youtube_username"
                  noLabelPadding
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="@username oder Kanal"
                  topMargin="mt-4"
                  value={values.youtube_username}
                />
              </div>
              <div>
                <Input
                  error={touched.linkedin_username && errors.linkedin_username}
                  forceLight
                  inputPaddingClass="px-3"
                  label="LinkedIn"
                  name="linkedin_username"
                  noLabelPadding
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Profil-URL oder Username"
                  topMargin="mt-4"
                  value={values.linkedin_username}
                />
              </div>

              <div className="mt-6 flex flex-col gap-2 text-sm text-rb-black">
                <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-rb-widget-border bg-rb-grey/70 p-3 text-left leading-5">
                  <input
                    type="checkbox"
                    className="mt-0.5 h-4 w-4 shrink-0 rounded border-rb-lite-grey text-rb-green focus:ring-rb-green"
                    name="legal_age_accepted"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.legal_age_accepted}
                  />
                  <span className="flex-1 text-left">Du musst bestätigen, dass du volljährig bist.</span>
                </label>
                {touched.legal_age_accepted && errors.legal_age_accepted && (
                  <div className="text-red-500 text-sm">{errors.legal_age_accepted}</div>
                )}
                <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-rb-widget-border bg-rb-grey/70 p-3 text-left leading-5">
                  <input
                    type="checkbox"
                    className="mt-0.5 h-4 w-4 shrink-0 rounded border-rb-lite-grey text-rb-green focus:ring-rb-green"
                    name="privacy_policy_accepted"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.privacy_policy_accepted}
                  />
                  <span className="flex-1 text-left">Ich stimme hiermit der Verarbeitung meiner Daten zu. Ich habe die <a href="https://www.reachbird.io/de/datenschutz" target="_blank" className="font-semibold text-rb-green underline">Datenschutzerklärung</a> gelesen und verstanden.</span>
                </label>
                {touched.privacy_policy_accepted && errors.privacy_policy_accepted && (
                  <div className="text-red-500 text-sm">{errors.privacy_policy_accepted}</div>
                )}
                <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-rb-widget-border bg-rb-grey/70 p-3 text-left leading-5">
                  <input
                    type="checkbox"
                    className="mt-0.5 h-4 w-4 shrink-0 rounded border-rb-lite-grey text-rb-green focus:ring-rb-green"
                    name="tc_accepted"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.tc_accepted}
                  />
                  <span className="flex-1 text-left">Ich stimme hiermit den Nutzungsbedinungen zu.</span>
                </label>
                {touched.tc_accepted && errors.tc_accepted && (
                  <div className="text-red-500 text-sm">{errors.tc_accepted}</div>
                )}
                <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-rb-widget-border bg-rb-grey/70 p-3 text-left leading-5">
                  <input
                    type="checkbox"
                    className="mt-0.5 h-4 w-4 shrink-0 rounded border-rb-lite-grey text-rb-green focus:ring-rb-green"
                    name="newsletter_opt_in"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.newsletter_opt_in}
                  />
                  <span className="flex-1 text-left">Ja, ich möchte per E-Mail-Newsletter über Trends, Aktionen, Funktionen und Services informiert werden. Abmeldung jederzeit möglich. <span className="text-rb-lighter-grey">(Optional)</span></span>
                </label>
              </div>

              <button
                type="submit"
                className="submit mt-6 h-12 w-full rounded-xl bg-rb-green text-center font-semibold text-white transition hover:bg-rb-green/90 active:shadow-outer"
              >
                Profil einreichen!
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}